import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../../hooks/hooks";
import Table from "../../../../../../../common/components/table-manager/v1.1/table";
import { selectAccountTypesListItems } from "../../../../../../../redux/account-types/selector";
import { accountTypes } from "../../../../../../../redux/account-types/action";
import PageLoader from "../../../../../../../components/PageLoader";
import { journeyLeg } from "../../../../../../../redux/journeyLeg/action";
import { selectJourneyLegListItems } from "../../../../../../../redux/journeyLeg/selector";
import { selectListItems } from "../../../../../../../redux/library/selector";

const ManagementJourneyLeg = ({ selectedOrder }) => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const itemsData = useSelector(selectJourneyLegListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const libraryData = useSelector(selectListItems)
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'ShipmentLegId', headerName: 'ShipmentLegId', searchField: 'Name', sortable: true, filter: true, filterType: 'text' },
      {
        field: 'ShippingStatusId', headerName: 'Shipping Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.ShippingStatus, isRowColorDecider: true },
        sortable: true,
        filter: false
      },
      { field: 'Description', headerName: 'Description', searchField: 'Description', sortable: true, filter: true, filterType: 'text' },

      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
    ]);
  }

  useEffect(() => {
    createColumnDefs()
  }, [pageData, pageSize])


  return (
    <>
      {itemsData?.isLoading ? <PageLoader /> :
        <Table
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'JourneyId',
          }}
          columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
          enableFilter={true}
          paginationData={itemsData?.result?.pagination}
          headingName="Journey Legs" />
      }

    </>
  );
};

export default ManagementJourneyLeg;


